import React from "react";
import { Empty, Space, Tag, Typography } from "antd";

const { Paragraph, Text } = Typography;

export interface StreamChatEvent {
  kind: "tool.started" | "tool.finished" | "tool.failed" | "info";
  text: string;
}

interface StreamChatPanelProps {
  answer?: string;
  running?: boolean;
  events?: StreamChatEvent[];
  emptyText?: string;
}

const eventColor = (kind: StreamChatEvent["kind"]) => {
  if (kind === "tool.failed") return "red";
  if (kind === "tool.finished") return "green";
  if (kind === "tool.started") return "blue";
  return "default";
};

const StreamChatPanel: React.FC<StreamChatPanelProps> = ({
  answer,
  running = false,
  events = [],
  emptyText = "回复与工具时间线会显示在这里。",
}) => (
  <Space direction="vertical" size={8} style={{ width: "100%", minHeight: 200 }}>
    {events.length > 0 && (
      <Space direction="vertical" size={4}>
        {events.map((event, index) => (
          <Tag key={`${event.kind}-${index}`} color={eventColor(event.kind)}>
            {event.text}
          </Tag>
        ))}
      </Space>
    )}
    {answer ? (
      <Paragraph style={{ whiteSpace: "pre-wrap", marginBottom: 0 }}>{answer}</Paragraph>
    ) : running ? (
      <Text type="secondary">生成中...</Text>
    ) : (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
    )}
  </Space>
);

export default StreamChatPanel;
